import fetch from "../utils/fetch";

//测评商品活动列表
export const fetchEvaluationList = (params) =>
  fetch(`/evaluation/goods/list`, {
    method: "get",
    params,
  });

//添加活动
export const fetchAddActivity = (data) =>
  fetch(`/evaluation/goods`, {
    method: "post",
    data,
  });

//审核
export const fetchAudit = (data) =>
  fetch(`/evaluation/examine`, {
    method: "put",
    data,
  });

//奖金操作
export const fetchBonusAct = (data) =>
  fetch(`/evaluation/bonus`, {
    method: "put",
    data,
  });

//查询测评详情
export const fetchEvaluationDetails = (tryEvaluationGoodsId) =>
  fetch(`/evaluation/goods/${tryEvaluationGoodsId}`);

//查询用户测评列表
export const fetchEvaluationUserList = (params) =>
  fetch(`/evaluation/user/list`, {
    method: "get",
    params,
  });

export const fetchEvaluationsList=(params)=>{
  return fetch(`/point/evaluate/list`, {
    method: "get",
    params,
  });
}